import { render } from "./CommonFormWithRoleEditor.vue?vue&type=template&id=58f4e96a&ts=true&lang=pug"
import script from "./CommonFormWithRoleEditor.vue?vue&type=script&lang=ts"
export * from "./CommonFormWithRoleEditor.vue?vue&type=script&lang=ts"

import "./CommonFormWithRoleEditor.vue?vue&type=style&index=0&id=58f4e96a&lang=scss"

import exportComponent from "C:\\Users\\ZiegFreeze\\Documents\\Work\\upa-fast-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__